import React from 'react'
import { Route } from "react-router-dom";

import { CentroMonitoreoCliente } from './CentroMonitoreoCliente';
import { CentroMonitoreoMaquinas } from './CentroMonitoreoMaquinas';
import { CentroMonitoreoDetalle } from './CentroMonitoreoDetalle';

export const CentroMonitoreoMainScreen = () => { 
    return (
        <div className="main-container">
            <Route    
                path="/CentroMonitoreo/Main"
                component={() => <CentroMonitoreoCliente />}
            />
            <Route
                path="/CentroMonitoreo/Maquinas/:jd_org_id"
                component={() => <CentroMonitoreoMaquinas />}
            />
            <Route
                path="/CentroMonitoreo/Detalle/:jd_machine_id"
                component={() => <CentroMonitoreoDetalle />}
            />
        </div>
    );
};